module.exports = __webpack_public_path__ + "img/amex.76bbecd.png";